import React from "react";
import { useEffect, useRef, useState } from "react";
import { getSectionHeight, getAdjustingFontSizeByHeightWidth, getScreenSize, ColourPalette, isSafari, getIsTablet } from "../globalConstants";
import { DownloadButtonsMobile } from "./DownloadButtonsMobile";
import ChallengeTileImage from "../assets/friendsPlayingPoker.jpg";
import AppLogoOrange from "../assets/appLogoAccentOrange.png";
import DuplicationIcon from "../assets/duplicationIcon.png";
import DelighterAnimation from "../assets/deligtherAnimation.webp"
import DelighterStill from "../assets/delighterAnimation10.webp"
import { DownloadButtonsDesktop } from "./DownloadButtonsDesktop";
import { FlexiblePhone, FlexiblePhoneStillImage } from "./flexiblePhone";
import StoreCreativeBackground from '../assets/storeCreativeBackgrounds3.png';
import StoreCreativeBackgroundNarrow from '../assets/storeCreativeBackgroundsNarrow1.png';
import { Textfit } from 'react-textfit';
interface FeedbackEngineProps {
}

const header0_1 = "Decisions,"

const header0_2 = "Not Cards,"
const header0_3 = " Determine Your Success"
//const header1 = "Your decisions, not your cards, determine your performance"
const header2 = "- Everyone plays the <strong>same hands</strong> against the <strong>same AI opponents</strong>.\n\n- Your goal: <strong>Win more than other players</strong> by making better decisions."
const header2_Mobile = "Everyone plays the <strong>same hands</strong> against the <strong>same AI opponents</strong>.\n Your goal: <strong>Win more than other players</strong> by making better decisions."
const header3 = "Everyone gets dealt the same hand, reducing the role of luck in the game"
export const formatAnswer = (answer: string, style, splitSpans = false) => {
    if (splitSpans) {
        return (
            <div style={{ ...style, display: "flex", flexDirection: "column", gap: "0.75em" }}>
                {answer.split('\n').filter(line => line.trim() !== '').map((line, i) => (
                    <div key={i} style={{
                        flexDirection: "row",
                        display: "flex",
                        alignItems: "flex-start",
                    }}>
                        <span style={{ margin: 0, flexShrink: 0, paddingRight: "0.4em" }}>{"–"}</span>
                        <span style={{ margin: 0 }} dangerouslySetInnerHTML={{
                            __html: line.replace(/<strong>(.*?)<\/strong>/g, '<strong style="font-weight: 900; font-family: BoldItalic;">$1</strong>')
                        }}></span>
                    </div>
                ))}
            </div>
        )
    }
    // Split the answer by newlines and map to <p> elements, allowing HTML tags
    return answer.split('\n').map((line, index) => (
        <p
            key={index}
            style={style}
            dangerouslySetInnerHTML={{
                __html: line.replace(/<strong>(.*?)<\/strong>/g, '<strong style="font-weight: 900; font-family: BoldItalic;">$1</strong>')
            }}
        />
    ));
};

export const DuplicatePokerMobile: React.FC<FeedbackEngineProps> = () => {

    const [isVisible, setIsVisible] = useState(false);
    const [isVisible2, setIsVisible2] = useState(false);
    const divRef = useRef(null);
    const div2Ref = useRef(null);
    try {

        useEffect(() => {
            const observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            if (entry.target === divRef.current) {
                                setIsVisible(true);
                            } else if (entry.target === div2Ref.current) {
                                setIsVisible2(true);
                            }
                        } else {
                            if (entry.target === divRef.current) {
                                setIsVisible(false);
                            } else if (entry.target === div2Ref.current) {
                                setIsVisible2(false);
                            }
                        }
                    });
                },
                {
                    threshold: 0.1,
                }
            );
            if (divRef.current) {
                observer.observe(divRef.current);
            }
            if (div2Ref.current) {
                observer.observe(div2Ref.current);
            }

            return () => {
                if (divRef.current) {
                    observer.unobserve(divRef.current);
                }
                if (div2Ref.current) {
                    observer.unobserve(div2Ref.current);
                }
            };
        }, []);


        const fadeInStyle = {
            opacity: isVisible ? 1 : 0,
            transition: 'opacity 1s ease-in',
        };

        const heightReference = getScreenSize().height * 0.87

        return (
            <div ref={divRef} style={{
                height: "auto",
                width: "100%",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                display: "flex",
                position: "relative"
            }}>
                {/* Background layers — unchanged */}
                <div style={{ position: "absolute", width: "100%", height: "100%" }}>
                    <img
                        src={ChallengeTileImage}
                        alt="Daily Tournament Tile"
                        style={{
                            width: '100%',
                            height: 'auto',
                            objectFit: 'contain',
                            position: "absolute",
                            top: "50%",
                            right: 0
                        }}
                    />
                    <div style={{
                        position: "absolute",
                        height: "100%",
                        top: 0,
                        left: 0,
                        width: "100%",
                        background: 'linear-gradient(0deg, rgba(100,85,11,0) 0%, rgba(255, 229, 127, 0) 2%,rgba(255, 224, 100, 0) 49.9%, rgb(248, 211, 63) 50%,  rgb(255, 221, 121) 80%,  rgb(255, 235, 160) 100%)'
                    }}></div>
                    <div style={{
                        position: "absolute",
                        height: "100%",
                        top: 0,
                        left: 0,
                        width: "100%",
                        background: 'linear-gradient(0deg, rgba(256,256,256,0) 0%,rgba(256,256,256,0) 10%, rgba(256,256,256,0) 45%,rgba(256,256,256,0.2) 53%, rgba(256,256,256,0.5) 100%)'
                    }}></div>
                </div>

                <div style={{
                    height: "auto",
                    width: "95%",
                    flexDirection: "column",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    position: "relative"
                }}>

                    {/* ── TITLE BLOCK (outside the card, mirrors desktop) ── */}
                    <div

                        style={{
                            ...fadeInStyle,
                            width: "100%",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            marginTop: heightReference * 0.05,
                            marginBottom: "4%",
                        }}
                    >
                        {/* Large primary word — "Decisions," */}
                        <h1 style={{
                            color: "rgba(51, 41, 0, 1)",
                            fontFamily: "Bold",
                            fontSize: getAdjustingFontSizeByHeightWidth(
                                heightReference * 0.16,
                                getScreenSize().width * 0.9,
                                header0_1.length,
                                200
                            ),
                            textAlign: "center",
                            margin: 0,
                            lineHeight: 1,
                            WebkitTextStroke: isSafari ? "0.5px rgba(50, 50, 0, 0.6)" : undefined,
                            textShadow: isSafari ? undefined : "1px 1px 0px rgb(50, 50, 0)",
                        }}>
                            {header0_1}
                        </h1>

                        {/* Secondary row — "Not Cards," + faded " Determine Your Success" */}
                        <div style={{
                            marginTop: 8,
                            width: "100%",
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "flex-end",
                            flexWrap: "wrap",
                        }}>
                            <h3 style={{
                                fontFamily: "Bold",
                                fontSize: getAdjustingFontSizeByHeightWidth(
                                    heightReference * 0.05,
                                    getScreenSize().width * 0.44,
                                    header0_2.length,
                                    200
                                ),
                                color: "rgba(51, 41, 0, 1)",
                                margin: 0,
                                marginRight: 6,
                                lineHeight: 1,
                                textAlign: "center",
                            }}>
                                {header0_2}
                            </h3>
                            <h3 style={{
                                fontFamily: "Bold",
                                fontSize: getAdjustingFontSizeByHeightWidth(
                                    heightReference * 0.04,
                                    getScreenSize().width * 0.44,
                                    header0_3.length,
                                    200
                                ),
                                color: "rgb(51, 41, 0)",
                                opacity: 0.75,
                                margin: 0,
                                marginBottom: 2,
                                lineHeight: 1,
                                textAlign: "center",
                            }}>
                                {header0_3}
                            </h3>
                        </div>
                    </div>

                    {/* ── CARD (body copy + download buttons) ── */}
                    <div
                        style={{
                            ...fadeInStyle,
                            height: "auto",
                            minHeight: getScreenSize().width * 0.50,
                            width: "100%",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            padding: "3%",
                            borderRadius: "20px",
                            background: 'linear-gradient(135deg, rgb(255, 250, 231) 0%, rgb(255, 252, 238) 50%, rgb(255, 240, 180) 90%)',
                            boxShadow: `
                                0 8px 32px rgba(0, 0, 0, 0.08),
                                0 4px 16px rgba(0, 0, 0, 0.04),
                                0 2px 8px rgba(0, 0, 0, 0.02)
                            `,
                            border: "1px solid rgba(255, 255, 255, 0.6)",
                            backdropFilter: "blur(10px)",
                        }}>

                        <div style={{
                            height: "auto",
                            width: "100%",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            paddingLeft: 20,
                            paddingRight: 20,
                            marginTop: "4%",
                            marginBottom: "4%"
                        }}>
                            {formatAnswer(header2_Mobile, {
                                maxWidth: "100%",
                                zIndex: 5,
                                fontFamily: "MediumItalic",
                                fontSize: getAdjustingFontSizeByHeightWidth(
                                    heightReference * 0.28,
                                    getScreenSize().width * 0.80,
                                    header2_Mobile.length,
                                    88
                                ),
                                textAlign: "left",

                                color: "rgba(51, 41, 0, 1)"
                            }, true)}
                        </div>

                    </div>
                    <div
                        style={{ marginTop: "5%" }}>
                        <DownloadButtonsMobile placement="duplicate_poker"
                            style={{ width: getScreenSize().width * 0.4, zIndex: 5 }}
                        />
                    </div>

                    {/* ── DELIGHTER IMAGE (unchanged) ── */}
                    <div
                        style={{
                            ...fadeInStyle,
                            height: heightReference * 0.5,
                            width: "100%",
                            display: "flex",
                            position: "relative",
                            marginBottom: 40,
                            minHeight: getScreenSize().width * 0.6,
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            marginTop: "5%",

                        }}>
                        <div style={{
                            height: heightReference * 0.5,
                            width: heightReference * 0.5 / 2.02535,
                        }}>
                            <FlexiblePhoneStillImage marginHorizontal={"3%"}
                                marginTop={"1%"} image={DelighterStill} videoBorderRadius={(heightReference * 0.5) / 13}></FlexiblePhoneStillImage>

                        </div>
                    </div>

                </div>
            </div>
        )
    } catch (err) {
        console.error('FeedbackEngine:' + err)
        return (<div></div>)
    }
}

export const DuplicatePokerDesktop: React.FC<FeedbackEngineProps> = () => {


    const [isVisible, setIsVisible] = useState(false);
    const [isVisible2, setIsVisible2] = useState(false);
    const divRef = useRef(null);
    const div2Ref = useRef(null);
    try {

        useEffect(() => {
            const observer = new IntersectionObserver(

                (entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            if (entry.target === divRef.current) {
                                setIsVisible(true);
                            } else if (entry.target === div2Ref.current) {
                                setIsVisible2(true);
                            }
                        } else {
                            if (entry.target === divRef.current) {
                                setIsVisible(false);
                            } else if (entry.target === div2Ref.current) {
                                setIsVisible2(false);
                            }
                        }
                    });
                },
                {
                    threshold: 0.1, // Trigger when 50% of the div is visible
                }
            );
            if (divRef.current) {
                observer.observe(divRef.current);
            }
            if (div2Ref.current) {
                observer.observe(div2Ref.current);
            }

            return () => {
                if (divRef.current) {
                    observer.unobserve(divRef.current);
                }
                if (div2Ref.current) {
                    observer.unobserve(div2Ref.current);
                }
            };
        }, []);


        const fadeInStyle = {
            opacity: isVisible ? 1 : 0,
            transition: 'opacity 1s ease-in',
        };

        const flyInStyle = {
            transform: isVisible2 ? 'translateX(0)' : 'translateX(-200%)',
            transition: 'transform 1s ease-in-out',
        };

        const flyInStyle2 = {
            transform: isVisible2 ? 'translateX(0)' : 'translateX(-300%)',
            transition: 'transform 1s ease-in-out',
        };

        const widthReference = getScreenSize().width
        const heightReference = Math.min(getScreenSize().height, widthReference);
        const isMobileOrTablet = getIsTablet();
        return (

            <div style={{
                height: "auto",
                width: "100%",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
                display: "flex",
                position: "relative"
            }}>
                <div style={{ position: "absolute", width: "100%", height: "100%", display: "flex", background: "linear-gradient(180deg, rgb(255, 246, 210) 0%, rgb(255, 235, 160) 100%)", }}>
                    <div style={{ position: "absolute", width: getScreenSize().width > getScreenSize().height ? "50%" : "40%", height: "100%", display: "flex", left: 0, zIndex: 1, overflow: "hidden" }}>
                        <img
                            src={ChallengeTileImage} // Reference the imported image
                            alt="Daily Tournament Tile" // Provide an alt attribute
                            style={{
                                width: "100%",
                                objectFit: 'cover',
                                position: "absolute",
                                top: 0,
                                left: 0,
                                filter: 'brightness(1.1) contrast(1.05)', ...(getIsTablet() ? { height: "100%", right: 0 } : { width: "100%", left: 0, })
                            }}

                        />
                    </div>
                    <div style={{
                        position: "absolute",
                        height: "100%",
                        top: 0,
                        left: 0,
                        width: "100%",
                        justifyContent: "flex-start",
                        alignItems: "flex-start",
                        // background: 'linear-gradient(90deg, rgba(255, 233, 143,0) 40%, rgb(245, 218, 110,1) 50%,rgb(245, 218, 110,1) 53%, rgb(245, 218, 110,0) 53%)'
                        //background: 'linear-gradient(90deg, rgb(219, 187, 26) 0%,   rgb(227, 201, 67) 2%,   rgb(216, 194, 83) 7%, rgba(180,135,17,0) 15%,  rgba(229,189,23,0) 10%,  rgba(229,189,23,0) 40%, rgb(237, 204, 71) 50%,  rgb(246, 212, 109) 80%,  rgb(242, 217, 154) 100%)'
                    }}></div>
                    {<img
                        src={StoreCreativeBackground}
                        alt="Daily Tournament Tile"
                        style={{
                            width: "100%",
                            height: '100%',
                            objectFit: 'contain',
                            position: "absolute",
                            top: 0,
                            right: 0,
                            zIndex: 0
                        }}
                    />}
                    {/* <div style={{
                        position: "absolute",
                        width: "50%",
                        height: "100%",
                        display: "flex",
                        right: 0,
                        alignItems: "center",
                        justifyContent: "center",
                        opacity: 0.1,
                        backgroundImage: `url(${AppLogoOrange})`,
                        backgroundRepeat: "repeat",
                        backgroundSize: "20% auto", // or 'contain' or 'cover' depending on desired effect
                        backgroundPosition: "center"
                    }}>
                    </div> */}
                    {/* <div style={{
                        position: "absolute",
                        height: "100%",
                        top: 0,
                        left: 0,
                        width: "100%",
                        justifyContent: "flex-start",
                        alignItems: "flex-start",
                        background: 'linear-gradient(270deg, rgba(256,256,256,0) 0%,rgba(256,256,256,0.5) 10%, rgba(256,256,256,0.5) 45%,rgba(256,256,256,0.2) 53%, rgba(256,256,256,0.2) 100%)'
                    }}></div> */}
                </div>
                <div style={{
                    height: heightReference * (getScreenSize().width > getScreenSize().height ? 0.9 : 0.8),
                    minHeight: getScreenSize().width * 0.42,
                    width: "95%",
                    flexDirection: "row",
                    display: "flex",
                    justifyContent: "center", alignItems: "center",
                    position: "relative", zIndex: 1
                }}>

                    <div
                        style={{
                            ...fadeInStyle,
                            height: "100%", width: getScreenSize().width > getScreenSize().height ? "50%" : "40%", display: "flex", marginTop: 40, marginBottom: 40,
                            flexDirection: "column", justifyContent: "center",
                            alignItems: "center"
                            , transform: "translateX(-3.5%)", // Fixed transform syntax
                        }}>
                        <div style={{
                            height: heightReference * (getScreenSize().width > getScreenSize().height ? 0.40 : 0.32) * 2.02535,
                            width: heightReference * (getScreenSize().width > getScreenSize().height ? 0.40 : 0.32),
                        }}>
                            <FlexiblePhoneStillImage marginHorizontal={"3%"}
                                marginTop={"1%"} image={DelighterStill} videoBorderRadius={70 * (getScreenSize().width * 0.2 / 400)}></FlexiblePhoneStillImage>

                        </div>
                        <div style={{
                            height: "100%", width: "100%", position: "absolute", flexDirection: "column", justifyContent: "center",
                            alignItems: "center"
                            , transform: "translateX(-3.5%)",
                        }}>

                        </div>
                    </div>
                    <div
                        ref={divRef}
                        style={{
                            ...fadeInStyle,
                            height: "100%", width: getScreenSize().width > getScreenSize().height ? "50%" : "60%", display: "flex",
                            flexDirection: "column", justifyContent: "center",
                            alignItems: "center", position: "relative", paddingRight: "6%", paddingLeft: "1%",

                            zIndex: 8
                        }}>
                        {/* Title above the box */}
                        <div style={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            marginBottom: "4%",
                            marginLeft: "10%",
                        }}>
                            <h1 style={{
                                width: "100%",
                                zIndex: 5,
                                fontFamily: "Bold",
                                fontSize: getAdjustingFontSizeByHeightWidth(heightReference * 0.25, getScreenSize().width * (0.28), header0_1.length, 200),
                                textAlign: "center",
                                color: "rgba(51, 41, 0, 1)",
                                margin: 0,
                                lineHeight: 1,
                                // textShadow: "1px 1px 0px rgb(50, 50, 0)",
                                WebkitTextStroke: isSafari ? "0.5px rgba(50, 50, 0, 0.6)" : null,
                                textShadow: isSafari ? null : "1px 1px 0px rgb(50, 50, 0)",
                            }}>
                                {header0_1}
                            </h1>
                            <div style={{ marginTop: 10, width: "100%", display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "flex-end" }}>
                                <h3 style={{
                                    zIndex: 5,
                                    fontFamily: "Bold",
                                    fontSize: getAdjustingFontSizeByHeightWidth(heightReference * 0.04, getScreenSize().width * (0.2), header0_2.length, 200),
                                    textAlign: "center",
                                    color: "rgba(51, 41, 0, 1)",
                                    margin: 0,
                                    marginLeft: 4,
                                    marginRight: 10,
                                    lineHeight: 1,
                                    whiteSpace: "nowrap",
                                }}>
                                    {header0_2}
                                </h3>
                                <h3 style={{
                                    zIndex: 5,
                                    fontFamily: "Bold",
                                    fontSize: getAdjustingFontSizeByHeightWidth(heightReference * 0.04, getScreenSize().width * (0.3), header0_3.length, 200),
                                    textAlign: "center",
                                    color: "rgb(51, 41, 0)",
                                    opacity: 0.75,
                                    margin: 0,
                                    marginBottom: 1,
                                    lineHeight: 1,
                                    whiteSpace: "nowrap",
                                }}>
                                    {header0_3}
                                </h3>
                            </div>
                        </div>
                        <div style={{

                            marginLeft: "10%",
                            width: "100%",
                            justifyContent: "center",
                            alignItems: "center",
                            position: "relative",
                            paddingTop: "2%",
                            paddingRight: "5%",
                            paddingLeft: "5%",
                            paddingBottom: "0%",
                            borderRadius: "20px",
                            background: 'linear-gradient(135deg, rgb(255, 250, 231) 0%, rgb(255, 252, 238) 50%, rgb(255, 240, 180) 90%)',
                            // Professional shadow with subtle depth
                            boxShadow: `
        0 8px 32px rgba(0, 0, 0, 0.08),
        0 4px 16px rgba(0, 0, 0, 0.04),
        0 2px 8px rgba(0, 0, 0, 0.02)
    `,
                            // Subtle border for definition
                            border: "1px solid rgba(255, 255, 255, 0.6)",
                            // Better backdrop for glass-like effect
                            backdropFilter: "blur(10px)",
                            // Smooth transitions for hover effects
                            transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)"
                        }}>
                            {/* <h1 style={{
                                maxWidth: "100%",
                                zIndex: 5,
                                // More refined text shadow
                                textShadow: "0 2px 4px rgba(255, 255, 255, 0.8), 0 1px 2px rgba(0, 0, 0, 0.1)",
                                fontFamily: "Medium",
                                fontSize: getAdjustingFontSizeByHeightWidth(heightReference * 0.25, getScreenSize().width * (0.25), header1.length, 88),
                                justifyContent: "center",
                                textAlign: "center",
                                // Better text contrast
                                color: "rgba(51, 41, 0, 1)",
                                marginBottom: "1rem"
                            }}>
                                {header1}
                            </h1> */}

                            <div style={{
                                height: "auto",
                                width: "100%",
                                position: "relative",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flexDirection: "row",

                                marginBottom: "6%",
                            }}>
                                {getIsTablet() ? null : <div style={{
                                    height: "100%",
                                    maxWidth: "27%",
                                    objectFit: 'contain',
                                    position: "relative",
                                    justifyContent: "center", alignItems: "center",
                                    marginRight: "2%"
                                    // Color filter to change black lines to dark brown and add shadow

                                }}>
                                    <img
                                        src={DuplicationIcon}
                                        alt="Daily Tournament Tile"
                                        style={{
                                            height: 150 * (getScreenSize().width / 1920),
                                            width: "100%",
                                            objectFit: 'contain',

                                            position: "relative",
                                            // Color filter to change black lines to dark brown and add shadow
                                            filter: "brightness(0) saturate(100%) invert(16%) sepia(30%) saturate(2000%) hue-rotate(30deg) brightness(90%) contrast(100%) drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1))"
                                        }}
                                    />
                                    <div style={{ position: "relative", display: "flex", width: "100%", justifyContent: "center", alignItems: "center" }}>
                                        <p
                                            style={{ fontSize: getAdjustingFontSizeByHeightWidth(heightReference * 0.07, getScreenSize().width * (0.1), header3.length, 88), maxWidth: "90%", textAlign: "center", fontFamily: "italic" }}
                                        >{header3}</p>
                                    </div>
                                </div>}
                                <div style={{
                                    height: "auto",
                                    width: "100%",
                                    position: "relative",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    flexDirection: "column",
                                    marginTop: "2%",

                                }}>
                                    {formatAnswer(header2, {
                                        maxWidth: "100%",
                                        textShadow: "0 1px 2px rgba(255, 255, 255, 0.8)",
                                        zIndex: 5,
                                        fontFamily: "MediumItalic",
                                        fontSize: getAdjustingFontSizeByHeightWidth(heightReference * 0.25, getScreenSize().width * (0.30), header2.length, 88),
                                        textAlign: "left",
                                        marginTop: "3%",

                                        width: "100%",
                                        color: "rgba(51, 41, 0, 1)"
                                    })}
                                </div>
                            </div>


                        </div>
                        <div style={{ justifyContent: "center", alignItems: "center", display: "flex", marginLeft: "10%", marginTop: "10%", width: "100%", height: heightReference * 0.12 }}>
                            {isMobileOrTablet ?
                                <div style={{ width: "65%", justifyContent: "center", alignItems: "center", display: "flex" }}>
                                    <DownloadButtonsMobile placement="duplicate_poker" />
                                </div>
                                :

                                <DownloadButtonsDesktop placement="duplicate_poker"
                                    width={getScreenSize().width * 0.4}
                                    height={"100%"}
                                />
                            }
                        </div>
                    </div>
                </div>
            </div >
        )
    } catch (err) {
        console.error('FeedbackEngine:' + err)
        return (<div></div>)
    }
}